// extracted by mini-css-extract-plugin
export var button = "quantity-selector-module--button--fPX6N";
export var disabledClass = "quantity-selector-module--disabledClass--59K2Q";
export var quantityText = "quantity-selector-module--quantityText--yI7Um";
export var selector = "quantity-selector-module--selector--SKttM";
export var selectorWrap = "quantity-selector-module--selectorWrap--DlG2i";